<template>
  <RouterView v-slot="{ Component, route }">
    <KeepAlive :include="cachedViewList">
      <component :is="Component" v-if="Component" :key="route.name" />
    </KeepAlive>
  </RouterView>
</template>
<script setup lang="ts">
  import { KeepAlive, onMounted } from 'vue';
  import { RouterView } from 'vue-router';

  import { useEntryURLStore } from './store/entry-url';

  import { useCachedViews } from '@/router';

  const cachedViewList = useCachedViews();
  const entryURLStore = useEntryURLStore();
  onMounted(() => {
    // 记录进入应用的首次页面路径
    console.log('🏠🏠🏠🏠🏠记录进入应用的首次页面路径🏠🏠🏠🏠', window.location.href);
    entryURLStore.setEntryURL(window.location.href);
  });
</script>
<style></style>
